import { render, staticRenderFns } from "./landing-page-how-it-works.vue?vue&type=template&id=fa4d502c&scoped=true&lang=pug"
import script from "./landing-page-how-it-works.js?vue&type=script&lang=js&external"
export * from "./landing-page-how-it-works.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-how-it-works.vue?vue&type=style&index=0&id=fa4d502c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4d502c",
  null
  
)

export default component.exports